import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import { usePopper } from 'react-popper';
import { BKJDropdown } from '../../BKJDropdown/index.js';
import { mergeRefs } from '../../BKJSelect/utils/mergeRefs.js';
import { Portal } from '../../Portal/Portal.js';
import { getPopperOptions, optionsVariant } from '../BKJComboBoxAsync.utils.js';
import { useBKJComboBoxAsyncContext } from './BKJComboBoxAsync.context.js';
import { BKJComboBoxAsyncOptionsMapper } from './BKJComboBoxAsyncOptionsMapper.js';
const variantMap = {
    Search: 'SeamlessRounded',
};
// WEB-4815 / T010 / R4 / I-A02: visually-hidden style for the live-region
// node. Uses the BKJVisuallyHidden pattern established in WEB-4780 inline
// here to avoid adding another dependency.
const VISUALLY_HIDDEN_STYLE = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: 0,
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0, 0, 0, 0)',
    whiteSpace: 'nowrap',
    border: 0,
};
export const BKJComboBoxOptions = ({ overrides = [] }) => {
    const { error, isOpen, parentRef, getMenuProps, anchorElement, dropdownElement, setDropdownElement, portalTargetElement, searchValue, isDropdownReverse, isBusy, liveMessage, } = useBKJComboBoxAsyncContext();
    const popperOpts = useMemo(getPopperOptions, []);
    const { styles } = usePopper(anchorElement, dropdownElement, popperOpts);
    if (overrides.includes('NoInitialResults')) {
        if (typeof searchValue === 'string' && searchValue === '')
            return _jsx(Fragment, {});
    }
    return (_jsxs(Portal, { targetElement: portalTargetElement, children: [_jsx(BKJDropdown, { "$isOpen": isOpen, "$dropdownVariant": variantMap[optionsVariant], error: error, ...getMenuProps({
                    ref: mergeRefs([parentRef, setDropdownElement]),
                    style: styles['popper'],
                    // WEB-4815 / T009 / FR-002 / I-A01: listbox is aria-busy while
                    // the consumer-provided GQL context reports isLoading=true.
                    // Using `undefined` (not "false") so the attribute is absent
                    // rather than stringified as aria-busy="false" when not busy.
                    'aria-busy': isBusy ? true : undefined,
                }), openBorderLocation: isDropdownReverse ? 'bottom' : 'top', children: isOpen && _jsx(BKJComboBoxAsyncOptionsMapper, { overrides: overrides }) }), isOpen && (_jsx("div", { "aria-live": "polite", "aria-atomic": "true", "data-testid": "bkj-combobox-async-live-region", style: VISUALLY_HIDDEN_STYLE, children: liveMessage }))] }));
};
//# sourceMappingURL=BKJComboBoxAsyncOptions.js.map